import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Job from "interfaces/Job";
import * as $ from "jquery";
import * as moment from "moment";
import * as numeral from "numeral";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import JobCustomerAddress from "../../interfaces/JobCustomerAddress";
import "../../js/jquery.responsiveTabs";
import "./view-BC.css";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Job;
}

export default class ViewBc extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {} as any, // Will be assigned to when componentDidMount is called.
        };
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        var jobCustomerAddresses = [];
        if (this.state.data.jobCustomerAddresses) {
            for (let i = 0; i < this.state.data.jobCustomerAddresses.length; i++) {
                jobCustomerAddresses.push(
                    <JobCustomerAddressView
                        key={i}
                        jobCustomerAddress={this.state.data.jobCustomerAddresses[i]}
                    />
                );
            }
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/jobs-bc">Projects</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Project Details</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.name}</h3>
                    <div id="horizontalTab">
                        <Link to={"/jobs/edit/" + this.state.data.id} className="tab--edit">
                            <i className="icon-edit"></i>
                        </Link>
                        <ul>
                            <li>
                                <a href="#job-overview">Project Overview</a>
                            </li>
                            <li>
                                <a href="#related-quotes">Related Quotes</a>
                            </li>
                        </ul>
                        <div id="job-overview">
                            <div className="box style1">
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">ID</span>
                                        <span className="field-item">{this.state.data.id}</span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Code</span>
                                        <span className="field-item">
                                            {this.state.data.code}
                                        </span>
                                    </div>
                                </div>
                                {/*<div className="row">*/}
                                {/*    <div className="field-group col-sm-6">*/}
                                {/*        <span className="field-label">Bid Date</span>*/}
                                {/*        <span className="field-item">*/}
                                {/*            {this.state.data.bidDate &&*/}
                                {/*                moment(this.state.data.bidDate).format("LL")}*/}
                                {/*        </span>*/}
                                {/*    </div>*/}
                                {/*    <div className="field-group col-sm-6">*/}
                                {/*        <span className="field-label">Type</span>*/}
                                {/*        <span className="field-item">*/}
                                {/*            {this.state.data.jobTypeName}*/}
                                {/*        </span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Project Name</span>
                                        <span className="field-item">{this.state.data.name}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Description</span>
                                        <span className="field-item text-box">
                                            {this.state.data.description}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Estimated Cost</span>
                                        <span className="field-item">
                                            {this.state.data.costEstimate &&
                                                numeral(this.state.data.costEstimate).format("$0,0.00")}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Address</span>
                                        <span className="field-item">
                                            {this.state.data.address}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Address2</span>
                                        <span className="field-item">
                                            {this.state.data.address2}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">City</span>
                                        <span className="field-item">{this.state.data.city}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">State</span>
                                        <span className="field-item">{this.state.data.state}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Zip</span>
                                        <span className="field-item">{this.state.data.county}</span>
                                    </div>
                                </div>
                                {/*<div className="row">*/}
                                {/*    <div className="field-group col-sm-12">*/}
                                {/*        <span className="field-label">Salesperson</span>*/}
                                {/*        <span className="field-item">*/}
                                {/*            {this.state.data.salesPerson}*/}
                                {/*        </span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <h5 className="section-seprate">Project Customer Information</h5>
                                {jobCustomerAddresses}
                            </div>
                        </div>
                        <div id="related-quotes">
                            <table
                                className="table simple-datatable"
                                style={{ width: "100%" }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%" }}>Quote ID</th>
                                        <th style={{ width: "50%" }}>Project Name</th>
                                        <th style={{ width: "15%" }}>Order Date</th>
                                        <th style={{ width: "15%" }}>Address</th>
                                        <th style={{ width: "15%" }}>City</th>
                                        <th style={{ width: "15%" }}>State</th>
                                        <th style={{ width: "15%" }}>Zip</th>
                                        <th style={{ width: "15%" }}>Contact</th>
                                        <th style={{ width: "15%" }}>Phone Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.orders && this.state.data.orders.map((item, index) => {
                                        let quoteId = item.parentQuoteId.toString();

                                        if (item.quote) {
                                            if (item.quote.isMaster) {
                                                quoteId += "M";
                                            }
                                            if (item.quote.revisionDate) {
                                                quoteId += ", rev " + moment(item.quote.revisionDate).format("l");
                                            }
                                            if (item.quote.isDraft) {
                                                quoteId += " (Draft)";
                                            }
                                        }

                                        return (
                                            <tr key={item.parentQuoteId}>
                                                <td>{quoteId}</td>
                                                <td>
                                                    <Link to={`/quotes/${quoteId}`}>
                                                        {this.state.data.name}
                                                    </Link>
                                                </td>
                                                <td>{item.date ? moment(item.date).format("LL") : "-"}</td>
                                                <td>{item.shippingAddress}</td>
                                                <td>{item.shippingCity}</td>
                                                <td>{item.shippingState}</td>
                                                <td>{item.shippingZip}</td>
                                                <td>{item.customerContactName}</td>
                                                <td>{item.customerPhone}</td>
                                                {/*<td>*/}
                                                {/*    {item.quote ? numeral(item.quote.price).format("$0,0.00") : "-"}*/}
                                                {/*</td>*/}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "jobs/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Job;

                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${data.name} - Project - ${SITE_NAME}`;

                if ($("#horizontalTab").length == 1) {
                    var $tabs = $("#horizontalTab");
                    $tabs.responsiveTabs({
                        rotate: false,
                        startCollapsed: "accordion",
                        collapsible: "accordion",
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}

interface JobCustomerAddressProps {
    jobCustomerAddress: JobCustomerAddress;
}

const JobCustomerAddressView: React.FC<JobCustomerAddressProps> = ({
    jobCustomerAddress,
    ...rest
}) => {
    return (
        <div className="view-bc">
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Customer Id</span>
                    <span className="field-item">
                        {jobCustomerAddress.customerId}
                    </span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Customer Number</span>
                    <span className="field-item">{jobCustomerAddress.customerNo}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-12">
                    <span className="field-label">Customer Name</span>
                    <span className="field-item">
                        {jobCustomerAddress.customerName}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Address</span>
                    <span className="field-item">
                        {jobCustomerAddress.address}
                    </span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Address 2</span>
                    <span className="field-item">{jobCustomerAddress.address2}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">City</span>
                    <span className="field-item">{jobCustomerAddress.city}</span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">State</span>
                    <span className="field-item">{jobCustomerAddress.state}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Zip</span>
                    <span className="field-item">{jobCustomerAddress.zip}</span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Phone Number</span>
                    <span className="field-item">{jobCustomerAddress.phoneNo}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Contact Name</span>
                    <span className="field-item">{jobCustomerAddress.contact}</span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Contact Number</span>
                    <span className="field-item">{jobCustomerAddress.contactNo}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Contact Email</span>
                    <span className="field-item">{jobCustomerAddress.email}</span>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/view-BC.tsx